$(function () {
    let $selector = $('.js-model-gallery');

    $selector.on('init', function(event, slick){
        let $lazyloadImages = $('img.lazyload', $selector);
        $lazyloadImages.each(function (i,e) {
            lazySizes.loader.unveil(e);
        });
    });

    $selector.slick({
        rows: 2,
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 3,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    })

});